import ReactDOM from "react-dom";
import BrowserRouter from 'react-router-dom/BrowserRouter';
import React from 'react';
import {Provider} from 'react-redux';

import App from './app/App';
import createStore from "./store/createStore";

const MOUNT_NODE = document.getElementById("root");

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__

// Create store
const store = createStore(preloadedState);

let render = () => {
  ReactDOM.hydrate(
    <Provider store={store}>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </Provider>,
    MOUNT_NODE
  );
};

if (process.env.NODE_ENV === "development") {
  if (module.hot) {
    module.hot.accept("./app/App", () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      })
    );
  }
}

render();